import { useContext, useMemo } from 'react';
import { Switch } from '@ascd/witsby-components';
import { Box } from '@mui/material';
import isEmpty from 'lodash/isEmpty';
import { ASCD_ID } from '@constants';
import { AppContext } from '@contexts/appContext';
import { DashboardContext, eDashboardActionType } from '@contexts/dashboardContext';

const AdminDashboardSidebarCreatedBy = () => {
  const {
    dispatch,
    state: { sideBarFilter },
  } = useContext(DashboardContext);

  const { selectedInstitution, createdByOrganizationId, allInstitutionsId } = sideBarFilter;

  const {
    state: { currentInstitution },
  } = useContext(AppContext);

  // Handle institution selection filter for ASCD admins
  const currentSelectedInstitution = useMemo(() => {
    if (!isEmpty(selectedInstitution)) return selectedInstitution;
    return {
      value: currentInstitution._id,
      label: currentInstitution.name,
    };
  }, [currentInstitution._id, currentInstitution.name, selectedInstitution]);

  const DASHBOARD_CREATED_BY = [
    {
      _id: ASCD_ID,
      name: 'ASCD Content',
    },
    ...(currentSelectedInstitution.value !== ASCD_ID
      ? [
          {
            _id: currentSelectedInstitution.value,
            name:
              currentSelectedInstitution?.label === 'ALL'
                ? 'Other Institutional Content'
                : 'My Institutional Content',
          },
        ]
      : []),
  ];

  if (currentSelectedInstitution?.label === 'ASCD') return <Box />;
  const isAllSelected = isEmpty(createdByOrganizationId);
  return (
    <Box
      className="created-by"
      sx={(theme) => ({
        p: 2,
        border: '1px solid',
        borderColor: theme.palette.grey[500],
        borderRadius: theme.border.radius.REGULAR,
      })}>
      <Box
        sx={(theme) => ({
          mb: 1,
          color: theme.palette.grey[200],
          fontSize: theme.font.size.REGULAR,
          fontWeight: theme.font.weight.BOLD,
        })}>
        Created By:
      </Box>
      {DASHBOARD_CREATED_BY.map((type) => {
        const defaultChecked = createdByOrganizationId?.includes(type._id);
        return (
          <Box
            key={type._id}
            sx={{
              mb: 1,
              display: 'flex',
              alignItems: 'center',
            }}>
            <Switch
              inputProps={{ 'aria-label': type.name }}
              checked={isAllSelected || defaultChecked}
              onChange={(_, value) => {
                let data = { ...sideBarFilter };
                let tempCreatedByOrganizationId;

                if (currentSelectedInstitution?.label === 'ALL') {
                  if (value) {
                    tempCreatedByOrganizationId =
                      type._id === ASCD_ID
                        ? [...createdByOrganizationId, ASCD_ID]
                        : [
                            ...createdByOrganizationId,
                            ...(allInstitutionsId as string[]).filter(
                              (createdBy: string) => createdBy !== ASCD_ID,
                            ),
                          ];
                  } else {
                    tempCreatedByOrganizationId =
                      type._id === ASCD_ID
                        ? (allInstitutionsId as string[]).filter(
                            (createdBy: string) => createdBy !== ASCD_ID,
                          )
                        : [ASCD_ID];
                  }
                } else if (value) {
                  tempCreatedByOrganizationId = [...createdByOrganizationId, type._id];
                } else {
                  tempCreatedByOrganizationId =
                    type._id === ASCD_ID ? [currentSelectedInstitution.value] : [ASCD_ID];
                }

                data = {
                  ...sideBarFilter,
                  createdByOrganizationId: tempCreatedByOrganizationId as string[],
                };

                dispatch({
                  type: 'SIDEBAR_FILTER' as eDashboardActionType.SIDEBAR_FILTER,
                  data,
                });
              }}
            />
            <Box
              sx={(theme) => ({
                ml: 0.5,
                fontSize: theme.font.size.SMALL,
              })}>
              {type.name}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default AdminDashboardSidebarCreatedBy;
